module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.16.0.0.box.611.496.412.52.q.100"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.16.0.0.box.611.496.412.52.q.100"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.1.0.box.169.972.1303.1400.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.0.box.169.972.1301.698.q.60"
    }
  }, [_vm._v("The men who formed Company C of the 9th Tennessee Infantry, known as the \"Southern Confederates,\" came from the Mount Carmel, Covington, Mason, Stanton, Randolph, Mount Zion (Munford) and Portersville (Salem) communities of West Tennessee. These communities of the original members were basically farming communities; however, this does not mean that they were uneducated nor poor. On the contrary, at least one third of the 126 men who left their homes and families that May morning, were either college graduates or came directly from college to enlist. Of the known professions, eleven were farmers, seven were laborers, five were teachers, four were clerks and two were ministers. This group also included at least one theological student, a carpenter, a merchant, a physician and a silversmith.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.1.box.169.1679.1302.309.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  }), _vm._v("Eight of the original members were married and three were widowers, two were without families and at least two others were married during the war. Their average age at the time of enlistment was twenty-two and a half. Fifty-five members were born in Tennessee, eleven in South Carolina, seven in Virginia, six in North Carolina, one in Alabama and four in Ireland.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.2.box.170.2002.1300.154.q.20"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.2.0"
    }
  }), _vm._v("The average height of the 9th Tennessee soldier, as taken from recorded Oaths of Allegiance and Disability Certificates, was 5'6\" with a range from 5' to 6'4.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.3.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.16.1.3.box.171.2165.1301.207.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.3.0"
    }
  }), _vm._v("On the surface, Company C, the \"Southern Confederates,\" or for that matter, the 9th Tennessee as a whole, was very similar in fact to other units of the Army of Tennessee. For example, the following chart compares Company C of the 9th Tennessee"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.17.1.0.box.246.359.1303.154.q.50"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  }), _vm._v("\nInfantry to Company H of the 1st Tennessee Infantry (Sam Watkins' company of \"Co. Aytch\" fame) and Company B of the 20th Tennessee Infantry:")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.3.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.4.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.6.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.8.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.11.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.12.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.15.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.17.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.18.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.19.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.20.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.21.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.22.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.23.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.24.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.25.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.26.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.27.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.28.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.29.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.30.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.31.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.1.0.box.246.359.1303.154.q.50"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gimg_graphic",
    attrs: {
      "id": "block.17.2.0.box.62.594.1510.1192.q.10"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.31.1.0"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[graphic]",
      "src": "data/content-0013.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.31.1.0.1"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.17.3.0.box.248.1943.1331.260.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.3.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.3.0.box.248.1943.1331.205.q.60"
    }
  }, [_vm._v("Twenty-seven of the \"Southern Confederates\" original mem bers were killed, fifty-five were wounded of which fifteen died, four were prisoners, fourteen deserted (many to join cavalry regiments) and eleven were present at the surrender.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.3.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.17.3.1.box.298.2158.1252.45.q.60"
    }
  }, [_vm._v("Why did these men go to war? Though long in their graves, we")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "block.17.4.0.box.248.2304.1301.90.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.4.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_footnote",
    attrs: {
      "id": "para.17.4.0.box.248.2304.1301.90.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.32.0.0"
    }
  }), _vm._v("*Company H was in the same brigade from Shiloh to the end of the war. Company B was in a different brigade but in the same army.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.1.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.18.1.0.box.169.362.1303.1242.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.18.1.0.box.169.362.1299.469.q.60"
    }
  }, [_vm._v("have here the rare opportunity to let the soldiers answer for themselves. In Captain Wood's reply to Miss Thompson at the presentation of Company C's flag at Clopton's Campground (see page 22), he stated: \"The rights, equality and justice for which our fathers fought have been denied us, our overtures for peace and justice have been treated with contempt; our arguments and entreaties have been met with insults, and we are now menaced with invasion. There is no alternative left us but to meet the fanatic on the battlefield.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.1.box.169.853.1302.583.q.60"
    }
  }, [_vm._v("But my predominant question is this: After so many hardships and so many losses, why did they keep on fighting even when failure seemed inevitable? Though these men were fighting for their homes and their way of life, after years of hard campaigning, the shining glow of patriotism faded from their faces and primal instincts engulfed them. During the shock of battle, high ideals left their minds and they fought simply for survival. They fought with and for their brothers—both their brothers by blood and their brothers by fire. As many as 26 sets of brothers entered military service under the Southern Confederate's banner. By April of 1865, all were brothers.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.18.1.2.box.172.1452.1300.152.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.1.2.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.3.0.0"
    }
  }), _vm._v("Individually, the \""), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.4.0.0"
    }
  }), _vm._v("Southern Confederates"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.5.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.6.0.0"
    }
  }), _vm._v("\" were one of th"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.7.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.8.0.0"
    }
  }), _vm._v("e most well educated,"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.9.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.10.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.11.0.0"
    }
  }), _vm._v(" zealously religious "), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.12.0.0"
    }
  }), _vm._v("and unbelievably gall"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.13.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.14.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.15.0.0"
    }
  }), _vm._v("ant group of men with"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.16.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.17.0.0"
    }
  }), _vm._v(" a devotion to duty u"), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.18.0.0"
    }
  }), _vm._v("nequaled in either army.")])]), _vm._v(" "), _c('div', {
    staticClass: "gimg_table",
    attrs: {
      "id": "block.18.2.0.box.180.1805.1286.583.q.30"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15.w.18.0.0.1"
    }
  }), _c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "[table]",
      "src": "data/content-0014.png"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.18.0.0.2"
    }
  })])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9361cff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content0015.vue
// module id = 66
// module chunks = 0